import { SplatImage } from "./splat-image.model";
import { Point } from "./point.interface";

export class SplatObject {
    id: number;
    imageKey: string;
    center: { x: number, y: number };
    rotation: number;
    image: SplatImage;
    selected: boolean = false;

    constructor(id: number, imageKey: string, center: { x: number, y: number }, rotation: number, image?: SplatImage, selected?: boolean) {
        this.id = id;
        this.imageKey = imageKey;
        this.center = center;
        this.rotation = rotation;
        this.image = image;
        this.selected = selected;
    }

    contains(point: Point): boolean {
        if (!this.image) {
            console.warn(`error in contains(). object "${this.imageKey} ${this.id}" has no image`);
            return false;
        }

        // the corner of the square (closest to the origin)
        const corner: any = {x: this.center.x - this.image.size.w / 2, y: this.center.y - this.image.size.h / 2};

        // the point returned to origin
        const po: any = {x: point.x - corner.x, y: point.y - corner.y};

        return po.x >= 0 && po.x <= this.image.size.w && po.y >= 0 && po.y <= this.image.size.h;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-object.model.ts